import { mergeMap } from 'rxjs/operators';
import { IEpic, isTypeOfAndGetPayload } from '@cbridge-utils/redux-observable';
import { downloadFileFromResponse } from '@cbridge-utils/file';
import { toApiSort } from '@cbridge-utils/datagrid';
import { catchApiError, IClientApiDependencySegment } from '@cbridge-packages/api';
import { createApiErrorNotification } from '@cbridge-packages/notification';
import { SymbolAction } from '../symbol.action';

type IDependencies = IClientApiDependencySegment;

export const exportSymbolsEpic: IEpic<{}, IDependencies> = (action$, _, dependencies) => action$.pipe(
  isTypeOfAndGetPayload(SymbolAction.exportFile.started),
  mergeMap((params) => {
    const { symbolGroup, search, sort } = params;
    return dependencies.api.exportCoreSymbols({ symbolGroup, search, sort: toApiSort(sort) }).pipe(
      mergeMap((response) => {
        downloadFileFromResponse(response);
        return [];
      }),
      catchApiError((error) => {
        return [
          SymbolAction.exportFile.failed({ params, error }),
          createApiErrorNotification(error),
        ];
      }),
    );
  }),
);
